module.exports = __webpack_public_path__ + "img/user.68f2a6aa.svg";